export const fmtBytes = (n: number): string => {
  if (n < 1024) return `${n} B`;
  if (n < 1_048_576) return `${(n / 1024).toFixed(0)} KB`;

  return `${(n / 1_048_576).toFixed(1)} MB`;
};
